module.exports = __webpack_public_path__ + "img/aeroland-client-logo-07-hover.b3f85e2d.png";